angular
	.module('AutoPrequal')
	.controller('birthdayDayCtrl', birthdayDayCtrl);

birthdayDayCtrl.$inject = ['$scope', '$rootScope', 'DataFactory', 'ScrollFactory'];

function birthdayDayCtrl($scope, $rootScope, DataFactory, ScrollFactory) {

	$rootScope.progressCurrent = 5;
	$rootScope.progressMobCurrent = 5;
	$scope.data = DataFactory.appData.applicant;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.birthday;
	$scope.goToStep = ScrollFactory.goToStep;

	if (DataFactory.appData.applicant.apBirthDateDD) {
		$scope.selectedDay = DataFactory.appData.applicant.apBirthDateDD;
	}
	else {
		$scope.selectedDay = "";
	}

	DataFactory.appData.applicant.apBirthDateDD = $scope.selectedDay;
	$rootScope.continueDisabled = $scope.selectedDay === "" ? true : false;
	$scope.$watch(function () {
		return DataFactory.appData.applicant.apBirthDateDD
	}, function (newValue, oldValue) {
		if (newValue) {
			$scope.selectedDay = newValue;
		}
	});

	$rootScope.$watch('currentStep', function (newVal) {
		if (newVal && newVal === "birthdayDay" && $scope.selectedDay) {
			$rootScope.continueDisabled = false;
		}
	})

	$scope.birthMonth = $scope.content.month_list_full[DataFactory.appData.applicant.apBirthDateMM];
	$scope.$watch(function () {
		return DataFactory.appData.applicant.apBirthDateMM;
	}, function (newValue, oldValue) {
		if (newValue) $scope.birthMonth = $scope.content.month_list_full[DataFactory.appData.applicant.apBirthDateMM];
	})

	$scope.$watch(function () {
		return DataFactory.appData.applicant.apBirthDateMM
	}, function (newVal, oldVal) {
		if (newVal && newVal.match("01|03|05|07|08|10|12")) {
			$scope.daysLength = 31;
		}
		else if (newVal.match("02")) {
			$scope.daysLength = 29;
		}
		else $scope.daysLength = 30;
	})


	$scope.nextStep = function (day) {
		DataFactory.appData.applicant.appState.birthdayDay = true;
		if (day) {
			$scope.data.apBirthDateDD = day;
			DataFactory.setData($scope.data);
		}
		ScrollFactory.showStep("birthdayYear");
		ScrollFactory.goToStep("birthdayYear");
	}

	$rootScope.birthdayDayNextStep = function () {
		if ($scope.selectedDay) {
			$scope.data.apBirthDateDD = $scope.selectedDay;
			DataFactory.setData($scope.data);
		}
		ScrollFactory.showStep("birthdayYear");
		ScrollFactory.goToStep("birthdayYear");
		return true;
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("birthdayMonth");
		ScrollFactory.goToStep("birthdayMonth");
	}
}
